/**
 *  PreloaderScene
 *
 *  Created by Legman on 7/10/2015.
 *
 */

import Common   from "./Common";

export default class PreloaderScene extends P3.Scene {
    constructor() {
        super();

    }

    init() {
        super.init();

        //--set renderer bg colour--//
        Common.renderer.backgroundColor = 0x0f73c3;
    }

    appear() {
        super.appear();
    }

    resize() {
        this.x = (P3.View.width - Common.STAGE_WIDTH) * 0.5;
        this.y = (P3.View.height - Common.STAGE_HEIGHT) * 0.5;
    }

    update() {
    }
}